import { APPLE_REDIRECT_URI, APPLE_CLIENT_ID } from '../../../../constants/url';

import appleImg from '../../../../images/common/btn_apple.svg';

const AppleLogin = () => {
  const handleAppleLogin = () => {
    const redirectUri = encodeURIComponent(APPLE_REDIRECT_URI);
    // const scope = 'name email';
    // const loginUrl = `https://appleid.apple.com/auth/authorize?response_type=code&client_id=${APPLE_CLIENT_ID}&redirect_uri=${redirectUri}&scope=${scope}&response_mode=form_post`;

    const loginUrl = `https://appleid.apple.com/auth/authorize?response_type=code&client_id=${APPLE_CLIENT_ID}&redirect_uri=${redirectUri}&response_mode=query`;

    window.location.href = loginUrl;
  };

  return (
    <div className="apple-login-container">
      <button data-login="apple" title="애플 아이디로 로그인하기" onClick={handleAppleLogin}>
        <img src={appleImg} alt="애플 로그인" />
      </button>
    </div>
  );
};

export default AppleLogin;